import {MultiLanguageString} from "./multi-language-string";
import {ISkill} from "./i-skill";

export class Skill {
    public constructor(public description: MultiLanguageString) {
    }

    public static fromInterface(iSkill: ISkill): Skill {
        return new Skill(MultiLanguageString.fromInterface(iSkill.description));
    }
}
